import { Ellipsis } from "lucide-react";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { NotificationsRepository } from "@/api/notifications/repository";
import { NotificationsService } from "@/api/notifications/service";
import { useBreakpoints } from "@/hooks/useBreakpoints";
import { useNotificationsStore } from "@/store/notifications/slice";
import type { IMenuOption } from "@/ui-kit";
import { IconButton, Menu } from "@/ui-kit";

export const HeaderMenu = () => {
  const { t } = useTranslation();
  const { isMobile } = useBreakpoints();

  const repository = useMemo(() => {
    return new NotificationsRepository(new NotificationsService(), {
      abort: true,
    });
  }, []);

  const menuOptions: IMenuOption[] = useMemo(() => {
    return [
      {
        id: "read_all",
        text: t("action.read_all"),
      },
      {
        id: "archive_all",
        text: t("action.delete_all"),
      },
    ];
  }, [t]);

  const handleReadAll = useCallback(() => {
    useNotificationsStore.getState().readAll();
    repository.markAllAsRead();
  }, [repository]);

  const handleArchiveAll = useCallback(() => {
    useNotificationsStore.getState().archiveAll();
    repository.deleteAll();
  }, [repository]);

  const onMenuChange = useCallback(
    (id: string) => {
      if (id === "read_all") {
        handleReadAll();
      }
      if (id === "archive_all") {
        handleArchiveAll();
      }
    },
    [handleReadAll, handleArchiveAll],
  );

  return (
    <Menu options={menuOptions} onSelect={onMenuChange} placement="bottom-end">
      <IconButton
        size={isMobile ? "md" : "sm"}
        variant={isMobile ? "ghost" : "soft"}
        color="neutral"
        content={<Ellipsis />}
      />
    </Menu>
  );
};
